

export enum EPlants {
    MetalCactus = "metal_cactus",
    PlasmaMushroom = "plasmashroom",
    BioBacteria = "recycling_bacteria",
    Algae = "algae",
    ModifiedInsects = "modified_insects",
}
